// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGDown = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#down__clip0)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "down__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 16,
      height: 16,
      children: /*#__PURE__*/_jsxs("g", {
        clipPath: "url(#down__clip1)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M8.14318 11.572H8.13146C8.13331 11.572 8.1352 11.5715 8.13704 11.5714C8.13901 11.5715 8.14121 11.572 8.14318 11.572Z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M12.8742 5.45816C13.0971 5.2353 13.4572 5.2353 13.68 5.45816C13.9028 5.68102 13.9029 6.04112 13.68 6.26396L8.53716 11.4068C8.42432 11.5196 8.28355 11.5702 8.13704 11.5714C7.99072 11.5699 7.85021 11.5138 7.73749 11.4068L2.59463 6.26396C2.37178 6.04111 2.37178 5.68102 2.59463 5.45816C2.81749 5.23534 3.17703 5.23532 3.39988 5.45816L8.13704 10.1953L12.8742 5.45816Z"
        })]
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#down__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0H16V16H0V0Z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "down__clip0",
      children: /*#__PURE__*/_jsx("rect", {
        width: 16,
        height: 16
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "down__clip1",
      children: /*#__PURE__*/_jsx("rect", {
        width: 16,
        height: 16
      })
    })]
  })]
}));
SVGDown.displayName = 'SVGDown';
export default SVGDown;